// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../v5/common/Components/IconV5.bs.js");
let ButtonsV5 = require("../../v5/common/Components/ButtonsV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function ReadMoreButton(props) {
  let children = props.children;
  return JsxRuntime.jsxs(ButtonsV5.OutlineButton.make, {
    href: props.href,
    size: "medium",
    className: "uppercase text-tan-blue-500 border-zinc-300 flex",
    children: [
      JsxRuntime.jsx("span", {
        children: children !== undefined ? children : "read more",
        className: "mr-16"
      }),
      JsxRuntime.jsx(IconV5.make, {
        icon: "arrow-right",
        size: 14
      })
    ]
  });
}

let make = ReadMoreButton;

exports.make = make;
/* IconV5 Not a pure module */
